module.exports = __webpack_public_path__ + "img/close.396f348e.svg";